import { generateUploadUrl } from '@/apis/upload';

function getImageDimensions(url) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.style.display = 'none';
    img.onload = () => {
      // 图片加载成功后，返回其原始宽高
      resolve({
        width: img.naturalWidth,
        height: img.naturalHeight,
      });
      img.remove();
    };
    img.onerror = () => {
      // 加载失败，例如URL无效或CORS问题
      reject(new Error('无法加载图片'));
      img.remove();
    };
    // 如果S3 bucket开启了CORS，可能需要设置 crossOrigin
    img.crossOrigin = 'anonymous';
    img.src = url;
  });
}

function getVideoDimensions(url) {
  return new Promise((resolve, reject) => {
    const video = document.createElement('video');
    video.style.display = 'none';
    video.preload = 'metadata'; // 仅加载元数据，提高效率

    video.onloadedmetadata = () => {
      // 视频元数据加载成功后，返回其原始宽高
      resolve({
        width: video.videoWidth,
        height: video.videoHeight,
      });
      video.remove(); // 完成后移除video元素
    };
    video.onerror = () => {
      // 加载失败
      reject(new Error('无法加载视频'));
      video.remove();
    };

    // 如果S3 bucket开启了CORS，可能需要设置 crossOrigin
    video.crossOrigin = 'anonymous';
    video.src = url;
  });
}

export const uploadFile = async (file, bizType, isImage = true) => {
  const res = await generateUploadUrl({
    fileName: file.name,
    bizType,
    fileSize: file.size,
    contentType: file.type,
  });

  await uploadToS3(res.data.url, file, file.type);

  const isPdf = file.type === 'application/pdf';
  if (isPdf) {
    return { url: res.data.fileKeyUrl, file: res.data.fileKey, fileName: res.data.fileName };
  }

  const dimensions = isImage ? await getImageDimensions(res.data.fileKeyUrl) : await getVideoDimensions(res.data.fileKeyUrl);
  return { url: res.data.fileKeyUrl, file: res.data.fileKey, width: dimensions.width, height: dimensions.height };
};

const uploadToS3 = async (url, file, contentType) => {
  const response = await fetch(url, {
    method: 'PUT',
    body: file,
    headers: {
      'Content-Type': contentType,
    },
  });

  if (!response.ok) {
    throw new Error(`Upload failed: ${response.statusText}`);
  }
};
